import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { JiraTicket } from '../interface/jirarequest';
import { RepositoryService } from '../service/repository.service';
import { CloudService } from './cloudservicetypes';
import { formatDate } from '@angular/common';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-newcloudservicerequest',
  templateUrl: './newcloudservicerequest.component.html',
  styleUrls: ['./newcloudservicerequest.component.css']
})
export class NewcloudservicerequestComponent implements OnInit {
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild('PaginatorCloudRequest', { static: true }) PaginatorCloudRequest: MatPaginator;
  @ViewChild('SortCloudRequest', { static: true }) SortCloudRequest: MatSort;
  selection = new SelectionModel<JiraTicket>(true, []);
  jiraRequestTable: JiraTicket[] = [];

  cloudServiceOptions = CloudService; //options for Cloud Services
  displayedColumns: string[] = ['issueId', 'self', 'createdDate', 'status', 'assignee'];
  selectedCloudService: any = '';
  selectedServiceType: any = '';
  availableServiceTypes: Array<any> = [];
  filteredServiceTypes: Array<any> = [];
  // JiraTicketDataSource = new MatTableDataSource<JiraTicket>(this.jiraRequestTable);
  totalRecords: any;

  filePath: string = 'assets/manual/Cloud_Service_Request_User_Manual.pdf';
  fileName: string = 'Cloud_Service_Request_User_Manual.pdf';

  ngAfterViewInit() {
    this.PaginatorCloudRequest.page.subscribe(() => {
      this.loadPageData();
    });
  }
  constructor(private router: Router, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    var isAuthSuccess = sessionStorage.getItem('isAuthSuccess');
    //if (isLoggedIn == null || isAuthSuccess == null) {
    if (isAuthSuccess == null) {
      this._toastService.warn("Please Sign In")
      this.router.navigate(['']);
    } else {
      this.loadPageData();
    }

  }
  onTabChange(index: number): void {
    // Assuming "My Request" is at index 1
    if (index === 1) {
      this.loadPageData();
      this.selectedCloudService = '';
      this.selectedServiceType = '';
      this.availableServiceTypes = [];
      this.filteredServiceTypes = [];
      this.cdRef.detectChanges();
    }
  }
  loadPageData() {
    let pageIndex = this.PaginatorCloudRequest.pageIndex;
    let pageSize = this.PaginatorCloudRequest.pageSize;
    let start = pageIndex * pageSize || 0;
    let end = start + pageSize || 10;
    this.fetchJiraTicket(sessionStorage.getItem('wwid'), start, end)
  }

  private fetchJiraTicket(userID: string, start: any, end: any): void {
    this.spinner.show();
  
    this.rs.fetchJiraTicket(userID, start, end).pipe(
      map((res: any) => {
        const sortedIssues = Array.isArray(res?.item?.accessibleIssues)
          ? res.item.accessibleIssues.sort((a: any, b: any) =>{
             return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()}
            )
          : [];
        return {
          issues: sortedIssues,
          totalRecords: res?.totalRecords || 0
        };
      })
    ).subscribe({
      next: (data) => {
        this.jiraRequestTable = data.issues;
        this.totalRecords = data.totalRecords;
        this.PaginatorCloudRequest.length = this.totalRecords;
        this.spinner.hide();
      },
      error: (error: any) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();
      }
    });
  }
  
  // private fetchJiraTicket(userID: any, start: any, end: any) {
  //   this.spinner.show();
  //   this.rs.fetchJiraTicket(userID, start, end).subscribe({
  //     next: (res: any) => {
  //       this.jiraRequestTable = Array.isArray(res?.item?.accessibleIssues) ? res?.item?.accessibleIssues : [];
  //       console.log(res?.item?.accessibleIssues)
  //       this.totalRecords = res.totalRecords;  // Set total count dynamically
  //       this.PaginatorCloudRequest.length = this.totalRecords;
  //       this.spinner.hide();
  //     },
  //     error: (error: any) => {
  //       this._toastService.error(error?.message || "An unexpected error occurred.");
  //       this.spinner.hide();
  //     }
  //   });
  // }


  handleFilteredReturn(filteredData: any) {
    this.filteredServiceTypes = filteredData
  }


  onChangeSelectedCloudService(event: any): void {
    this.selectedCloudService = event.value;
    const selectedService = this.selectedCloudService !== "finOps" ? this.cloudServiceOptions.find(service => service?.value === this.selectedCloudService) : '';
    if (selectedService !== '') {
      this.availableServiceTypes = selectedService.serviceType;
      this.filteredServiceTypes = [...this.availableServiceTypes];
    } else {
      this.availableServiceTypes = [];
      this.filteredServiceTypes = [];
    }
    this.selectedServiceType = '';

  }

  onChangeSelectedService(event: any): void {
    this.selectedServiceType = event.value;
  }
  dateFormat(date: any) {
    return formatDate(new Date(date), 'MMM dd yyyy HH:mm', 'en')
  }

}
